module.exports = __webpack_public_path__ + "static/media/5rsow6fjhqw11.2ff65860.jpg";